export function actionPt(action: string | undefined): string {
  if (action === 'create' || action === 'copy') {
    return ' incluído';
  }
  if (action === 'update') {
    return 'atualizado';
  }
  if (action === 'remove') {
    return 'excluído';
  }
  return '';
}

export type IAction = 'create' | 'remove' | 'update' | 'filter';
